import React, { useTransition } from "react";
import styles from "./SpecialOffers.module.css";
import { useTranslation } from "react-i18next"; // استيراد useTranslation
import { FaEnvelope, FaWhatsapp, FaPhone } from "react-icons/fa";
import ContactEmailSection from "../homePage/ContactEmailSection";
import { FaMapMarkerAlt } from "react-icons/fa";
import CountdownTimer from "./CountdownTimer";
import { Link } from "react-router-dom";

const products = [
  {
    name: "مفتاح إنارة ذكي",
    quantity: 15,
    image: "/images/SpecialOffers/01.png",
    link: "/dion-switch",
  },
  {
    name: "كاميرا ألوان خارجية",
    quantity: 7,
    image: "/images/SpecialOffers/02.png",
    link: "/4mp-colorVu",
  },
  {
    name: "كاميرا ألوان داخلية",
    quantity: 1,
    image: "/images/SpecialOffers/11.png",
    link: "/4mp-colorVu",
  },
  {
    name: "شاشة إنتركم",
    quantity: 1,
    image: "/images/SpecialOffers/04.png",
    link: "/kh6-series-ip-based",
  },
  {
    name: "إنتركم خارجي لمزيد من الأمان",
    quantity: 1,
    image: "/images/SpecialOffers/09.png",
    link: "/poe-villa",
  },
  {
    name: "وحدات تحكم بالمكيف",
    quantity: 6,
    image: "/images/SpecialOffers/03.png",
    link: "/ven-bus",
  },

  {
    name: "سماعات Bosch لصوت نقي",
    quantity: 6,
    image: "/images/SpecialOffers/05.png",
    link: "/ceiling-loudspeaker-6w",
  },
  {
    name: "أمبليفر TIS لأداء احترافي",
    quantity: 1,
    image: "/images/SpecialOffers/06.png",
    link: "/audio-matrix",
  },
  {
    name: "كابلات شنايدر لضمان الجودة",
    quantity: 0,
    image: "/images/SpecialOffers/07.png",
    link: "#",
  },
  {
    name: "مقويات إرسال لاتصال مستقر",
    quantity: 6,
    image: "/images/SpecialOffers/08.png",
    link: "/pro-6-lite",
  },
  {
    name: "شاشة 10 بوصة",
    quantity: 1,
    image: "/images/SpecialOffers/12.png",
    link: "/sat101",
  },

];

const position = [25.252372627898257, 55.3381967161324];

const ProductItem = ({ product }) => {
  return (
    <div className={styles.productCard}>
      <img
        src={product.image}
        alt={product.name}
        className={styles.productImage}
      />

      {product.quantity !== 0 && (
        <div className={styles.quantity}>
          <span className={styles.count}>{product.quantity}</span>
        </div>
      )}
      {product.quantity === 0 && (
        <div className={styles.quantitynull}>
          <span className={styles.count}>{product.quantity}</span>
        </div>
      )}

      <span className={styles.productName}>{product.name}</span>
    </div>
  );
};

const SpecialOffers = () => {
  const { t } = useTranslation(); // استخدام useTranslation

  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${position[0]},${position[1]}`;

  return (
    <section className={styles.offerContainer}>
      <CountdownTimer initialTime={10 * 24 * 60 * 60} />

      <h1> وفر أكثر وارتقِ بحياتك إلى مستوى ذكي🏡⚡ </h1>
      <h2>احصل على باقة المنزل الذكي المتكاملة بـ</h2>
      <div className={styles.price}>
        <div className={styles.discountPrice}>
          <span>25.200</span>
          <span style={{ fontWeight: "600", fontSize: "14px" }}>AED</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p style={{fontWeight: "bold"}}>فقط</p>
          {/* <p>بدلاً من</p>
          <span className={styles.originalPrice}>38.400</span> */}
        </div>
      </div>
      <p className={styles.contain}
      >
        شامل الآتي
      </p>
      <div className={styles.productGrid}>
        {products.map((product) => (
          <Link
            key={product.name}
            to={`/products${product.link}`}
            style={{ textDecoration: "none" }}
          >
            <ProductItem product={product} />
          </Link>
        ))}
      </div>
      <div className={styles.Warranty}>
        <p>✅ معاينة وتركيب مجاناً</p>
        <p>✅ مخططات مجانية</p>
        <p>✅ صيانة سنة مجاناً</p>
        <p>✅ ضمان 3 سنوات</p>
      </div>
      <button className={styles.orderBtn}> احجز الآن 📩</button>

      <section className={styles.contactSection}>
        <div className={styles.infoContainer}>
          <p className={styles.contactInfo}>
            <a
              href="https://wa.me/+971589445296"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contactLink}
            >
              <FaWhatsapp className={styles.icon} /> {t("about.whatsapp")}
            </a>
          </p>

          <p className={styles.contactInfo}>
            <a href="tel:+971555895194" className={styles.contactLink}>
              <FaPhone className={styles.icon} /> {t("about.phone")}
            </a>
          </p>
        </div>
      </section>
      <div className={styles.card} aria-label={t("location")}>
        <div className={styles.iconContainer}>
          <FaMapMarkerAlt className={styles.icon} />
        </div>

        <h3 className={styles.orderBtn}  style={{ color: '#fff', margin: "0 auto 20px auto", fontSize: "18px" }}>{t("locationTitle")}</h3>
        <p>{t("addressLine1")}</p>
        <p>{t("addressLine2")}</p>
      </div>
      <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
        <button className={styles.directionBtn}>
          {t("contact.map.getDirections")}{" "}
        </button>
      </a>
      {/* <p >اترك استفسارك وسنتواصل معك</p> */}
      <p className={styles.inquiry}>
        {" "}
        اترك استفسارك الآن، وسنتواصل معك سريعًا لنلبي احتياجاتك
      </p>

      <ContactEmailSection />
    </section>
  );
};

export default SpecialOffers;
